const languages = {
    english: 'english',
    german:  'german',
};

module.exports = languages;